<template>
    <div class="content-wrapper">
        <div class="row align-items-center">
            <div class="col-md-12 col-lg-6">
                <div class="d-flex align-items-center">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb p-0 d-flex align-items-center mb-primary">
                            <li class="breadcrumb-item page-header d-flex align-items-center">
                                <h4 class="mb-0">{{ $t('jobPosition.job_position_details') }}</h4>
                            </li>
                            <template v-if="this.$can('view_job_positions')">
                                <li class="ml-2">|</li>
                                <li>
                                    <a :href="urlGenerator(jobPositionWebUrl)"
                                       class="btn btn-link text-primary pl-2">{{
                                            $t('jobPosition.back_to_all_job_position')
                                        }}</a>
                                </li>
                            </template>
                        </ol>
                    </nav>
                </div>
            </div>
            <div class="col-md-12 col-lg-6">
                <div class="d-flex justify-content-lg-end mb-primary">
                    <div class="dropdown">
                        <button type="button"
                                class="btn btn-success dropdown-toggle"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                            {{ $t('action') }}
                            <app-icon name="chevron-down"/>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                            <a href="#" class="dropdown-item" @click="editJobPosition">
                                {{ $t('edit') }}
                            </a>
                            <a href="#" class="dropdown-item"  @click.prevent="deleteJobPosition">
                                {{ $t('delete') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="job-position-profile mb-primary">
            <div class="card card-with-shadow py-5 border-0" style="min-height: 220px;">
                <app-overlay-loader v-if="loader"/>
                <div v-else class="row">
                    <!-- Left Section (Title & Department) -->
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-5">
                        <div class="media border-right px-5 job-position-header-media align-items-center">
                            <div class="media-body user-info-header">
                                <h4>{{ jobPosition.title }}</h4>

                                <!-- Department Section Styled Like Employee View -->
                                <div class="media mt-2">
                                    <div class="align-self-center mr-3">
                                        <app-icon name="briefcase"/>
                                    </div>
                                    <div class="media-body">
                                        <p class="text-muted mb-0">{{ $t('department') }}</p>
                                        <p class="mb-0" v-if="jobPosition.department">
                                            {{ jobPosition.department.name }}
                                        </p>
                                        <p class="mb-0" v-else>
                                            {{ $t('not_added_yet') }}
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                    <!-- Right Section (Dates) -->
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-7">
                        <div
                            class="user-details px-5 px-sm-5 px-md-5 px-lg-0 px-xl-0 mt-5 mt-sm-5 mt-md-0 mt-lg-0 mt-xl-0">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                    <div class="border-right custom">
                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon name="calendar"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">
                                                    {{ $t('created_date') }}
                                                </p>
                                                <p class="mb-0">
                                                    {{ formatDateTimeToLocalDate(jobPosition.created_at) }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                    <div class="media mb-4 mb-xl-5">
                                        <div class="align-self-center mr-3">
                                            <app-icon name="calendar"/>
                                        </div>
                                        <div class="media-body">
                                            <p class="text-muted mb-0">
                                                {{ $t('updated_date') }}
                                            </p>
                                            <p class="mb-0">
                                                {{ formatDateTimeToLocalDate(jobPosition.updated_at) }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-job-position-modal
            v-if="isJobPositionModalActive"
            v-model="isJobPositionModalActive"
            :selected-url="updateUrl"
        />

        <app-confirmation-modal
            :message="promptSubtitle"
            :modal-class="modalClass"
            :icon="promptIcon"
            v-if="confirmationModalActive"
            modal-id="app-confirmation-modal"
            @confirmed="triggerConfirm"
            @cancelled="cancelled"
        />

    </div>
</template>

<script>
import {axiosDelete, urlGenerator} from '../../../../../common/Helper/AxiosHelper';
import {FormMixin} from "../../../../../core/mixins/form/FormMixin";
import JobPositionCreateEditModal from "../../Recruitment/JobPosition/JobPositionCreateEditModel.vue"; // Placeholder for JobPositionEditModal if you have it
import {formatDateTimeToLocalDate} from "../../../../../common/Helper/Support/DateTimeHelper";
import {mapState} from "vuex";
import {JOBPOSITION,JOBPOSITIONWEB} from "../../../../Config/ApiUrl";


export default {
    name: "JobPositionDetails",
    mixins: [FormMixin],
    components: {JobPositionCreateEditModal},
    props: {
        jobPositionId: {}
    },
    data() {
        return {
            jobPosition: {
                title: '',
                department: {name: ''},
                created_at: '',
                updated_at: ''
            },
            jobPositionWebUrl: JOBPOSITIONWEB,
            urlGenerator,
            formatDateTimeToLocalDate,
            tabIcon: 'briefcase',
            viewJobPositionModal: false,
            isJobPositionModalActive: false,
            confirmationModalActive: false,
            deleteUrl: '',
            promptAction: '',
            updateUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
        };
    },
    mounted() {
        // Fetch job position details on component mount
        this.$store.dispatch("getJobPositionDetails", this.jobPositionId);
    },
    methods: {
        cancelled() {
            this.confirmationModalActive = false;
        },

        editJobPosition() {
            this.updateUrl = `${JOBPOSITION}/${this.jobPositionId}`;
            this.isJobPositionModalActive = true;
        },

        // ✅ Delete job position functionality
        deleteJobPosition() {
            this.confirmationModalActive = true;
            this.deleteUrl = `${JOBPOSITION}/${this.jobPositionId}`;
            this.promptAction = 'delete_job_position';
            this.promptTitle = this.$t('are_you_sure');
            this.promptMessage = this.$t('jobPosition.you_are_going_to_remove_an_job_position_from_list');
        },

        // ✅ Confirmation Modal Close
        closeConfirmation() {
            $("#app-confirmation-modal").modal('hide');
            $(".modal-backdrop").remove();
            this.loading = false;
            this.confirmationModalActive = false;
            // ✅ Redirect using urlGenerator
            window.location.href = urlGenerator(`${JOBPOSITIONWEB}`);
        },

        // ✅ Handles confirm button in modal
        triggerConfirm() {
            if (this.promptAction === 'delete_job_position') {
                this.removeJobPosition(this.deleteUrl);
            }
        },

        // ✅ Delete request
        removeJobPosition(url) {
            this.loading = true;

            axiosDelete(url)
                .then(({ data }) => {
                    this.confirmationModalActive = false;
                    this.toastAndReload(data.message, 'job-position-table');
                })
                .catch(({ response }) => {
                    this.toastException(response.data);
                    this.confirmationModalActive = false;
                })
                .finally(() => this.closeConfirmation());
        }
    },
    computed: {
        ...mapState({
            jobPositionDetails: state => state.jobPosition.jobPosition,
            loader: state => state.loading,
        }),
    },
    watch: {
        jobPositionDetails: {
            handler: function (jobPosition) {
                this.jobPosition = jobPosition;
                if (jobPosition.title) {
                    let title = document.title.split('-');
                    title[0] = jobPosition.title;
                    document.title = title.join(' - ');
                }
            },
            deep: true
        }
    }
};
</script>
